<template>
  <label
    class="toggle-switch"
    :class="{
      'is-active': modelValue,
      'is-disabled': disabled,
      [`is-${color}`]: color,
      [`is-${size}`]: size !== 'normal',
    }"
  >
    <input
      type="checkbox"
      :checked="modelValue"
      :disabled="disabled"
      @change="$emit('update:modelValue', !modelValue)"
    />
    <i
      class="fa-solid toggle-icon"
      :class="modelValue ? 'fa-toggle-on' : 'fa-toggle-off'"
    />
    <span v-if="label" class="toggle-label">{{ label }}</span>
  </label>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    modelValue: { type: Boolean, default: false },
    label: { type: String, default: '' },
    color: { type: String, default: 'primary' },
    disabled: { type: Boolean, default: false },
    size: { type: String, default: 'normal' },
  },
  emits: ['update:modelValue'],
}
</script>

<style lang="scss" scoped>
.toggle-switch {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  cursor: pointer;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  &.is-disabled {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }
}

// Default (no color): use text color
.toggle-icon {
  font-size: 1.5em;

  .is-small & {
    font-size: 1.1em;
  }
  color: var(--toggle-color, var(--text-light));
  transition:
    color 0.15s ease,
    filter 0.15s ease;
}

.toggle-label {
  font-size: var(--text-sm);
  font-weight: var(--font-medium);
  color: var(--toggle-color, var(--text-light));
  transition: color 0.15s ease;
}

// Active: bolder label, brighter icon
.is-active > .toggle-icon {
  filter: brightness(1.1);
}

.is-active > .toggle-label {
  font-weight: var(--font-semibold);
}

// Color variants — always applied (inactive + active)
.toggle-switch {
  &.is-primary {
    --toggle-color: var(--brand);
  }
  &.is-danger {
    --toggle-color: var(--danger);
  }
  &.is-success {
    --toggle-color: var(--success);
  }
  &.is-warning {
    --toggle-color: var(--warning);
  }
  &.is-info {
    --toggle-color: var(--info);
  }
}
</style>
